export default __webpack_public_path__ + "static/IBMPlexMono400-f231d81762a7e0d3c431b402634c68d1.woff2";